<template>
  <div class="inforecordList">
    <el-row style="margin-bottom:20px">
      <el-col :span='6' style="height:20px"></el-col>
      <el-col :span='8'>
          会员姓名：{{serviceRow.name}}
      </el-col>
      <el-col :span='10'>
          手机号：{{serviceRow.phone}}
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      ref="multipleTable"
      class="myMemTable"
      style="width: 100%"
      border
      :key="serviceRow.type"
      :header-cell-style="{background:'#EFF1F5'}"
    >
    <template v-if="serviceRow.type == 1">
      <el-table-column align="center" prop="id" label="服务单号"></el-table-column>
      <el-table-column align="center" prop="startTime" label="服务日期">
        <template slot-scope="scope">
          {{scope.row.startTime | formatDateNoHouer | filterRow}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="startTime" label="服务时间">
        <template slot-scope="scope">
          {{scope.row.startTime | filterNoHouerTime | filterRow}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="endTime" label="结束时间">
        <template slot-scope="scope">
          {{scope.row.endTime | filterNoHouerTime | filterRow}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="serviceList" label="服务项目">
        <template slot-scope="scope">
            <el-row class="tableGoods" v-if="scope.row.serviceList.length > 0">
                <el-popover trigger="hover" placement="top">
                    <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                    <el-col slot="reference" class="myTitle">
                        <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                    </el-col>
                </el-popover>
            </el-row>
            <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="technicianName" label="员工">
        <template slot-scope="scope">
          {{scope.row.technicianName | filterRow}}
        </template>
      </el-table-column>
    </template>
    <template v-else>
      <el-table-column align="center" prop="orderId" label="订单编号" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" prop="createTime" label="购买时间" width="150"></el-table-column>
      <el-table-column align="center" prop="orderGoodsList" label="购买项目">
        <template slot-scope="scope">
            <el-row class="tableGoods" v-if="scope.row.orderGoodsList.length > 0">
                <el-popover trigger="hover" placement="top">
                    <span v-for="(i,index) in scope.row.orderGoodsList" :key="index">{{i.goodsName}}{{scope.row.orderGoodsList.length-1 == index ? '' : '，'}}</span>
                    <el-col slot="reference" class="myTitle">
                        <span v-for="(i,index) in scope.row.orderGoodsList" :key="index">{{i.goodsName}}{{scope.row.orderGoodsList.length-1 == index ? '' : '，'}}</span>
                    </el-col>
                </el-popover>
            </el-row>
            <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="paidInAmount" label="订单金额">
        <template slot-scope="scope">
          {{scope.row.orderType == 1 ? '￥'+scope.row.paidInAmount.toFixed(2):'￥'+scope.row.amountReceivable.toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="paidInAmount" label="实付金额">
        <template slot-scope="scope">
          {{'￥'+(Number(scope.row.paidInAmount)-Number(scope.row.giveChange)).toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="cutSmallChange" label="优惠金额">
        <template slot-scope="scope">
          {{'￥'+(Number(scope.row.cutSmallChange)+Number(scope.row.discount)).toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="salesmanName" label="销售员" show-overflow-tooltip></el-table-column>
    </template>
      <el-table-column align="center" prop="remark" label="备注" show-overflow-tooltip>
        <template slot-scope="scope">
          {{scope.row.remark | filterRow}}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-show="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px;text-align:right"
    ></el-pagination>
   
    <el-row class="btnOptions">
      <el-button class="darkBtn" @click="closeTab">关闭</el-button>
    </el-row>
  </div>
</template>
<script>
import {serviceOrderList, saleOrderList} from '@/api'

export default {
  props: ['serviceRow','dialogRecordVisible'],
  data() {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
    };
  },
  watch: {
    'dialogRecordVisible'(val){
      if(val){
        this.search()
      }
    }
  },
  created () {
    this.search()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    closeTab() {
      this.$emit("closeDialog", false);
    },
    search(){
      let postUrl = this.serviceRow.type == 1?serviceOrderList:saleOrderList;
      this.tableData = this.$options.data().tableData;
      postUrl({
        memberId:this.serviceRow.memberId,
        pageSize: this.pageSize,
        currentPage: this.currentPage
      }).then(res=>{
        this.total = res.data.totalNum;
        this.tableData = res.data.items;
      })
    }
  },
};
</script>
<style lang="less" scoped>
.inforecordList {
  padding: 0 20px 10px;
  .tableGoods {
    .myTitle {
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .btnOptions {
    margin: 40px 0 0 0;
    text-align: center;
    .el-button {
      min-width: 105px;
      height: 38px;
      border: none;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/inforecord.vue